import { useSelector } from "react-redux";
import OpenQuoteRepository from "src/repository/OpenQuoteRepository";
import {
    getSubmittedQuoteList,
    searchQuote,
    getOpenQuoteList,
    addMultipleQuote,
    setIsSuccessAction,
    getQuoteReasonList
} from "src/store/slice/model/OpenQuote";
import store from "src/storeWire";
import quoteDetailAPICallResponseMaker from "../service/QuoteDetailAPICall/quoteDetailAPICallResponseMaker";
import QuoteDetailRepository from "src/repository/QuoteDetailRepository";

export function useQuoteStore() {
    const addOpenQuote = useSelector((state) => state.entities.model_OpenQuote.addOpenQuote.data) //used
    const openQuoteList = useSelector((state) => state.entities.model_OpenQuote.openQuoteList); // used
    const submittedQuoteList = useSelector((state) => state.entities.model_OpenQuote.submittedQuoteList); // used
    const searchQuoteList = useSelector((state) => state.entities.model_OpenQuote.searchQuoteList); // used
    const isSuccessAction = useSelector((state) => state.entities.model_OpenQuote.isSuccessAction); // used
    const quoteReasonList = useSelector((state) => state.entities.model_OpenQuote.quoteReasonList); // used
    const statusList = quoteDetailAPICallResponseMaker.statusList; // used

    let data = {
        addOpenQuote,
        openQuoteList,
        submittedQuoteList,
        searchQuoteList,
        quoteReasonList,
        statusList,
        isSuccessAction
    };

    let fetch = {
        fetch_submitted_quote_list: async (params) => { // used
            return await store.dispatch(getSubmittedQuoteList(params))
        },
        fetch_search_quote_list: async (params) => { // used
            return await store.dispatch(searchQuote(params))
        },
        fetch_submitted_quote_export_url: async (params) => { // used
            return await new QuoteDetailRepository().getSubmittedQuoteExportUrl(params)
        },
        fetch_open_quote_list: async (params) => { // New call for Open quote // used
            return await store.dispatch(getOpenQuoteList(params))
        },
        get_RFQ_quantity: async (product, cpn) => {
            return await new OpenQuoteRepository().getRFQQuantity(product, cpn);
        },
        get_quote_reason_list: async () => { // DT - 21/08/2023 - US 11360: quote reason DDL - added API
            return await store.dispatch(getQuoteReasonList())
        }
    };
    let set = {
        clear_all_quote: async () => { // used
            return await new OpenQuoteRepository().clearAllQuote();
        },
        single_delete_quote: async (lineItemId) => { // used
            return await new OpenQuoteRepository().clearSingleQuote(lineItemId);
        },
        edit_quote_save: async (quoteData) => { // used
            return await new OpenQuoteRepository().editQuoteSave(quoteData);
        },
        submit_quote: async (params) => { //used
            return await new OpenQuoteRepository().submitQuote(params)
        },
        add_multiple_quote: async (params) => { //used
            return await store.dispatch(addMultipleQuote(params))
        },
        set_is_success_action: async (params) => { //used
            return await store.dispatch(setIsSuccessAction(params))
        },

    };
    return [data, fetch, set]
}